import { ChangeDetectionStrategy, Component, ViewEncapsulation, input, output } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MatExpansionModule } from '@angular/material/expansion';
import katex from 'katex';

import { ExperimentRunDetailComponent } from './experiment-run-detail.component';
import { ExperimentRun, ProbabilityExperimentDefinition } from './probability-experiment.model';

const COLOR_N = '#f97316'; // orange-500
const COLOR_SUCCESS = '#16a34a'; // green-600

function renderLatex(latex: string): string {
  return katex.renderToString(latex, { throwOnError: false, output: 'html', trust: true });
}

@Component({
  selector: 'dojo-experiment-run-log',
  standalone: true,
  imports: [MatExpansionModule, ExperimentRunDetailComponent],
  templateUrl: './experiment-run-log.component.html',
  styleUrl: './experiment-run-log.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: { class: 'block' },
})
export class ExperimentRunLogComponent {
  constructor(private readonly sanitizer: DomSanitizer) {}

  readonly runs = input.required<readonly ExperimentRun[]>();
  readonly experiment = input.required<ProbabilityExperimentDefinition>();
  readonly targetOutcomes = input.required<boolean[]>();
  readonly successProbability = input.required<number>();
  readonly runHover = output<number | null>();

  readonly successKLabelHtml: SafeHtml = this.sanitizer.bypassSecurityTrustHtml(renderLatex(`\\text{Success } k =`));
  readonly nLabelHtml: SafeHtml = this.sanitizer.bypassSecurityTrustHtml(renderLatex(`n =`));

  successValueHtml(count: number): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(renderLatex(`\\textcolor{${COLOR_SUCCESS}}{${count}}`));
  }

  trialsValueHtml(n: number): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(renderLatex(`\\textcolor{${COLOR_N}}{${n}}`));
  }

  isLastRun(run: ExperimentRun): boolean {
    const runs = this.runs();
    return runs.length === 1 || run.runNumber === runs[runs.length - 1].runNumber;
  }
}
